import { Table, Typography } from "antd";
import React from "react";
import { theme } from "../../../../assets/theme";

const Specifications = ({ product }) => {
  const columns = [
    {
      title: "Parameter",
      dataIndex: "parameter",
      key: "parameter",
      align: "center",
      className: "parameter-column",
      width: "40%",
    },
    {
      title: "Specification",
      dataIndex: "specifications",
      key: "specifications",
      align: "center",
      className: "specification-column",
      width: "60%",
    },
  ];

  return (
    <div style={{ margin: "24px 0" }}>
      <Typography.Title
        level={3}
        className="specifications-title"
        style={{ marginBottom: "16px", textAlign: "center" }}
      >
        Performance Specifications
      </Typography.Title>
      {product && (
        <Table
          dataSource={product.product_specification}
          columns={columns}
          pagination={false}
          showHeader={false} // Hide the table headers
          bordered
          style={{ borderRadius: "8px", overflow: "hidden" }} // Optional styling
        />
      )}
    </div>
  );
};

export default Specifications;
